import { Vec3 } from "@base/math/Vec3";
import { ISunSailData, PoleIndex, SunSailType } from "@biz/definitions/SunSailDefinitions";
import { Poles } from "@biz/items/sunSail/logic/Poles";
import { SunSailLogic } from "@biz/items/sunSail/logic/SunSailLogic";

export class OnePylonSystemLogic {
  static getRope1Length(sunSail: ISunSailData): number { // Seil1
    const pylonPoles = SunSailLogic.calcPylonPoles(sunSail);
    if (pylonPoles.length !== 1)
      return 0;

    const netPositions = SunSailLogic.calcNetPositionGroups(sunSail, {});

    const _B = netPositions[0][PoleIndex.B];
    const _D = netPositions[1][PoleIndex.D];

    const distInPoleIndex = (pylonPoles[0] + 2) % 4;
    const d = SunSailLogic.calcDistanceIn(sunSail, distInPoleIndex);

    return OnePylonSystemLogic.#getLinkageRopeLengthDirect(Vec3.len(_B, _D), d)
  }

  static #getLinkageRopeLengthDirect(distBD: number, oppositePylonDistIn: number): number { // Seil1
    const len = distBD + oppositePylonDistIn * 2 + 2;
    return Math.ceil(len);
  }

  static isOnePylonSystem(sunSail: ISunSailData): boolean {
    return sunSail.sunSailType === SunSailType.SolidayC && Poles.getCount(sunSail) === 4 && SunSailLogic.calcPylonCount(sunSail) === 1 && SunSailLogic.calcAxlePylonCount(sunSail) === 0;
  }

  static getIndirectPylon(sunSail: ISunSailData): number {
    if (!OnePylonSystemLogic.isOnePylonSystem(sunSail))
      return -1;
    const pylonPoles = SunSailLogic.calcPylonPoles(sunSail);
    return (pylonPoles[0] + 2) % 4;
  }
}